function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "166.598,125.09 162.685,92.755 155.449,78.257 138.178,70.485 129.246,105.564 135.925,116.158  126.473,127.855 127.021,142.891 108.078,167.973 90.816,164.066 74.65,177.98 57.378,177.98 32.873,199.73 24.524,198.609  5.574,154.578 0,151.805 33.986,97.774 43.465,86.068 45.682,48.177 51.275,40.386 45.135,33.123 61.284,12.522 62.406,4.165  74.65,0.269 127.021,45.942 135.396,27.566 158.232,22.011 164.911,25.906 164.911,42.046 173.834,44.856 192.756,44.856  199.462,59.327 198.896,67.108 197.218,82.154 200,86.068 198.896,136.768 198.34,140.117 176.05,132.873 "
});

var Svg15 = function Svg15(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MEX",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg15, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/15.640f679f.svg";
export { ForwardRef as ReactComponent };